import {BasePqmFieldValue} from "./BasePqmFieldValue";
import {PqmFieldRegister} from "./PqmFieldRegister";
import {getSelectedValue, setSelectedValue} from "../../Utils";
import {PqmPacket, PqmProcData} from "../pqmTypes";
import {UiRadioList} from "../../components/UiRadioList";
import {TreeSelector} from "../../TreeSelector";
import {UiTomSelect} from "../../components/UiTomSelect";
import {BaseCompanyForm} from "../../components/BaseCompanyForm";

export class PqmFieldCompany extends BasePqmFieldValue {
	static getValueTypes(): string[] {
		return [ "company:company_company" ];
	}

	beforeIndex() {
		// @ts-ignore
		this.muAppendContent(`<div mu="value:BaseCompanyForm#value"></div>`);
	}

	isFilled(): boolean {
		const v = this.getValue();
		return v && !!v.ic;
	}

	container_change() {
		this.onChange();
	}

	setDisabled(disabled: boolean) {
		(this.muNamedWidget.value as unknown as BaseCompanyForm).setDisabled(disabled);
	}

}

PqmFieldRegister.register(PqmFieldCompany);